import "./kendo.core.js";
import * as commonEngine from "@progress/kendo-spreadsheet-common";

export const __meta__ = {
    id: "spreadsheet.common",
    name: "Spreadsheet common engine",
    category: "web",
    description: "Spreadsheet component",
    depends: ["core"]
};

(function(kendo) {
    let $ = kendo.jQuery;
    $.extend(kendo.spreadsheet, commonEngine);
    kendo.spreadsheet.commonEngine = commonEngine;
})(kendo);